import { CertificazioneDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { FormRicercaClienti, RicercaClientiReducerType } from "./types";

const ricercaClientiReducer = (state: RootState): RicercaClientiReducerType => state.ricercaClienti;

export const elencoCertificazioniSelector = createSelector(
  ricercaClientiReducer,
  (state: RicercaClientiReducerType): CertificazioneDto[] => {
    return state.risultato?.items || [];
  }
);

export const numeroTotalePagineSelector = createSelector(
  ricercaClientiReducer,
  (state: RicercaClientiReducerType): number | undefined => {
    return state.risultato?.pageCount;
  }
);

export const isFirstPageSelector = createSelector(
  ricercaClientiReducer,
  (state: RicercaClientiReducerType): boolean => {
    return !!state.risultato?.isFirstPage;
  }
);

export const isLastPageSelector = createSelector(
  ricercaClientiReducer,
  (state: RicercaClientiReducerType): boolean => {
    return !!state.risultato?.isLastPage;
  }
);

export const riepilogoPaginazioneSelector = createSelector(
  ricercaClientiReducer,
  (state: RicercaClientiReducerType): string => {
    return (state.risultato?.pageCount || 0) > 0 ? state.risultato?.firstItemOnPage + '-' + state.risultato?.lastItemOnPage + ' su ' + state.risultato?.totalItemCount + ' elementi totali' : '';
  }
);

export const formRicercaClienteSelector = createSelector(
  ricercaClientiReducer,
  (state: RicercaClientiReducerType): FormRicercaClienti => {
    return state.form;
  }
);



